import React, { useEffect, useCallback } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import cn from 'classnames'
import { useQuery, useMutation, useApolloClient } from '@apollo/client'
import useSocket from 'use-socket.io-client'
import qs from 'query-string'

import { QUERY, MUTATION } from '../../apollo'
import LogoPixedenMusic from '../LogoPixedenMusic'
import Navigation from './Navigation'
import * as Icon from '../Icons'
import { loggedOutResponse, loggedInResponse } from '../../localStorage'

import styles from './layout.module.css'

function ProfileLayout({ children }) {
  const client = useApolloClient()
  let history = useHistory()
  let location = useLocation()

  const [socket] = useSocket(`${process.env.REACT_APP_WS_URI}`, {
    autoConnect: false,
  })

  const [checkMagicLink, { loading }] = useMutation(MUTATION.CHECK_MAGIC_LINK, {
    onError: (error) => {
      console.log(error.graphQLErrors[0].message)
    },
    update(cache, { data: { checkMagicLink } }) {
      const { token, refreshToken, user } = checkMagicLink
      if (token && refreshToken) {
        loggedInResponse(cache, { accessToken: token, refreshToken, user })
        history.replace('/profile')
      }
    },
  })

  const { data, refetch } = useQuery(QUERY.USER_INFO, { skip: loading })
  const userInfo = data?.userInfo

  const checkMagicLinkCB = useCallback(checkMagicLink, [checkMagicLink])

  useEffect(() => {
    const { token } = qs.parse(location.search)

    if ((data && !data.userInfo && token) || (!data && token)) {
      checkMagicLinkCB({ variables: { token } })
    }

    if (data && !data.userInfo) {
      history.replace('/login', { returnTo: location.pathname })
    }
  }, [data, history, location.pathname, location.search, checkMagicLinkCB])

  useEffect(() => {
    if (data && data.userInfo) {
      socket.connect()
      socket.on('connect', function () {
        socket.emit('room', data.userInfo.id)
      })
      socket.on('update', function (info) {
        if (process.env.NODE_ENV !== 'production')
          console.log('socket:update', { info })
        refetch()
      })
    }
    return () => {
      socket.disconnect()
    }
  }, [data, socket, refetch])

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.logo}>
            <LogoPixedenMusic />
          </Link>
          <div className={styles.navWrapper}>
            <Link to="/app" className={styles.link} style={{ marginRight: 26 }}>
              Browse
            </Link>
            {userInfo ? (
              <Link to="/profile" className={styles.link}>
                <span className={styles.profile}>
                  <span className={styles.name}>{userInfo.name}</span>
                  <div className={styles.profileImage}>
                    <Icon.UserMusic />
                  </div>
                </span>
              </Link>
            ) : null}
            <button
              className={cn(styles.link, styles.logoutLink)}
              onClick={() => loggedOutResponse(client)}
            >
              Log out <Icon.Logout className={styles.logoutIcon} />
            </button>
          </div>
        </div>
      </header>
      <div className={styles.content}>
        <div className={styles.contentInner}>
          <Navigation />
          {children}
        </div>
      </div>
    </div>
  )
}

export default ProfileLayout
